import axios from 'axios'
import { Toast } from 'vant'

// 统一接口域名配置（从环境变量读取）
export const BASE_URL = process.env.VUE_APP_BASE_URL || 'http://localhost:8081'

// 创建 axios 实例
const request = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器：自动加上 token（注册/登录除外）
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    const noTokenUrls = ['/api/member/login', '/api/company/login']
    const needToken = token && !noTokenUrls.includes(config.url)
    if (needToken) {
      config.headers['token'] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 需要重新登录的状态码
const AUTH_ERROR_CODES = [1001, 1002, 1003, 1004]

// 响应拦截器：统一处理登录失效/错误提示
request.interceptors.response.use(
  response => {
    const res = response.data
    if (AUTH_ERROR_CODES.includes(res.code)) {
      // 判断当前路径是否包含/my，如果是则跳转到登录页，否则弹出登录窗口层
      const currentPath = window.location.pathname + window.location.search + window.location.hash
      
      if (!currentPath.includes('/my')) {
        Toast(res.msg || '登录已失效，请重新登录')
        localStorage.removeItem('token')
        localStorage.removeItem('userType')
        localStorage.removeItem('userInfo')
        // 触发全局事件通知组件弹出登录窗口
        const loginRequiredEvent = new CustomEvent('login-required', {
          detail: { redirect: currentPath }
        })
        window.dispatchEvent(loginRequiredEvent)
      } else {
        Toast(res.msg || '登录已失效，请重新登录')
        localStorage.removeItem('token')
        localStorage.removeItem('userType')
        localStorage.removeItem('userInfo')
        window.location.href = '/login?redirect=' + encodeURIComponent(currentPath)
      }
      return Promise.reject(new Error(res.msg || '登录已失效'))
    }
    if (res.code !== 200) {
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    const msg = error.response?.data?.msg || error.message || '网络请求异常'
    return Promise.reject(new Error(msg))
  }
)

export { request }

export default request
